export interface Validation {
  pattern?: string;
  minLength?: number;
  maxLength?: number;
}

export interface Salesforce {
  fieldName: string;
  objectName?: string;
}

export function getSalesforceFieldName(salesforce: Salesforce): string {
  return salesforce.objectName
    ? `${salesforce.objectName}.${salesforce.fieldName}`
    : salesforce.fieldName;
}

export interface DynamicOptions {
  mappingFrom: string;
  mapping: Record<string, string[]>;
}

export interface VisibilityCondition {
  defaultVisibility?: boolean;
  from: string;
  if: string[];
}

export interface Field {
  name: string;
  displayName: string;
  type: string;
  required?: boolean;
  validation?: Validation;
  editable?: boolean;
  valueFrom?: string;
  salesforce?: Salesforce;
  options?: string[];
  default?: string;
  visible?: boolean;
  dynamicOptions?: DynamicOptions;
  visibilityCondition?: VisibilityCondition;
  requirePastDate?: boolean;
  requireFutureDate?: boolean;
  multiLine?: boolean;
  additionalInformation?: string;
  multiSelect?: boolean;
  example?: string;
  sectionTitle?: string;
  sectionFields?: Field[];
}

export interface SupportConfig {
  description: string;
  fields: Field[];
}

export interface RootConfig {
  [key: string]: SupportConfig;
}

export interface DynamicFieldSelection {
  [key: string]: string;
}

export interface FieldData {
  [key: string]: string;
}

export interface FieldValidation {
  [key: string]: boolean;
}

export interface FileUploadStatus {
  [key: string]: boolean;
}

export interface SalesforceUploadResponse {
  id: string;
  success: boolean;
  errors: any[];
}
